import React, { FC } from 'react';
import { UserRatingsResponse } from 'logic/api-models/api-models';
import { UserReview } from './UserReview';
import { Stack } from 'components/stack/stack';
import { getRatingsWithComment } from 'logic/utils/ratings';

type Props = {
  userRatings: UserRatingsResponse['ratings'];
  columns?: number;
};

export const UserReviewList: FC<Props> = ({ userRatings, columns = 1 }) => {
  const templateColumns = '1fr '.repeat(columns).trim();

  return (
    <Stack
      gap={1}
      flow={'row'}
      templateColumns={templateColumns}
      alignItems={'start'}
      style={{ marginBottom: 16 }}
    >
      {getRatingsWithComment(userRatings).map(({ comment = '', addedBy, createdAt }, idx) => (
        <UserReview author={addedBy} comment={comment} createdAt={createdAt} key={idx} />
      ))}
    </Stack>
  );
};
